module.exports = __webpack_public_path__ + "img/Screenshot 2022-08-09 173526.dd819d1d.png";